import styled from 'styled-components';
import { css, breakpoints } from '../../../../styles/theme';
import { FeatureDemandBannerStyled } from '../../FeatureDemandBannerStyled';
import { rem } from 'polished';

export const FeatureDemandBannerOV = styled(FeatureDemandBannerStyled)`
    
`;
